import { render, staticRenderFns } from "./GoTop.vue?vue&type=template&id=4f628b7e&scoped=true&"
import script from "./GoTop.vue?vue&type=script&lang=js&"
export * from "./GoTop.vue?vue&type=script&lang=js&"
import style0 from "./GoTop.vue?vue&type=style&index=0&id=4f628b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f628b7e",
  null
  
)

export default component.exports